import pako from "pako";


/**
 * Compresses URL search parameters using gzip compression and base64 encoding.
 * Used to reduce URL length when filter parameters exceed the maximum threshold.
 *
 * @param params - URLSearchParams object to compress
 * @returns Base64-encoded compressed string representation of the parameters
 */
export const compressFilters = (params: URLSearchParams): string => {
    const paramsObj = Object.fromEntries(params.entries());
    const json = JSON.stringify(paramsObj);
    const compressed = pako.gzip(json);
    return btoa(String.fromCharCode(...compressed));
};

/**
 * Decompresses a base64-encoded gzip string back to URLSearchParams.
 * Handles the reverse operation of compressFilters for URL parameter restoration.
 *
 * @param compressed - Base64-encoded compressed string
 * @returns URLSearchParams object with decompressed parameters, or empty params if decompression fails
 */
export const decompressFilters = (compressed: string): URLSearchParams => {
    try {
        const compressedData = Uint8Array.from(atob(compressed), (c) => c.charCodeAt(0));
        const json = pako.ungzip(compressedData, { to: "string" });
        const paramsObj = JSON.parse(json);
        return new URLSearchParams(paramsObj);
    } catch {
        return new URLSearchParams();
    }
};

